export default "__VITE_ASSET__DFbElBPk__"